import React from "react";
import Menu from "@material-ui/core/Menu";
import * as Icon from "react-feather";
import ConfirmDeleteDialog from "../ConfirmDeleteDialog";
import CloneFormDialog from "./CloneFormDialog";

const ProjectFormActionMenu = ({ Project_ID, form, handleDelete }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <button
        aria-controls={"formActions" + form.Form_ID}
        aria-haspopup="true"
        className="btn btn-transparent-dark btn-sm"
        onClick={handleClick}
      >
        <Icon.MoreVertical size={18} />
      </button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <CloneFormDialog
          Project_ID={Project_ID}
          Form={form}
          handleMenuClose={handleClose}
        />
        <ConfirmDeleteDialog
          Record_ID={form.Record_ID}
          Type="Form"
          Name={form.Form_Name}
          handleDelete={handleDelete}
          handleMenuClose={handleClose}
        />
      </Menu>
    </React.Fragment>
  );
};

export default ProjectFormActionMenu;
